import axios from "axios";
import React from "react";
import { useState } from "react";
import { API_BASE_URL } from "../../api/endPoint";
import get from "../../features/get";

export default function TeamPercentage({ modal, data }) {
  function handleClose() {
    modal(false);
  }
  const [win, setwin] = useState(data?.win == null ? 0 : data?.win);
  const [loss, setloss] = useState(data?.loss == null ? 0 : data?.loss);
  const [draw, setdraw] = useState(data?.draw == null ? 0 : data?.draw);
  const [win_percentage, setwin_percentage] = useState(
    data?.win_percentage == null ? 0 : data?.win_percentage
  );
  const [team_id, setManager] = useState(data?.team_id);
  function percentage(wins, losses, draws) {
    return (~~wins / (~~wins + ~~losses + ~~draws)) * 100;
  }
  let team = {
    win,
    loss,
    draw,
    wining_percentage: ~~percentage(win, loss, draw),
    team_id,
  };
  const handleCreate = (e) => {
    e.preventDefault();
    axios
      .post(`${API_BASE_URL}create/teamPercentage/`, team)
      .then((res) => console.log(res, "back end response"))
      .catch((err) => console.log(err, "error back end response"));
  };
  const handleUpdate = (e) => {
    e.preventDefault();
    axios
      .put(`${API_BASE_URL}update/teamPercentage/${data?.teampercent_id}`, team)
      .then((res) => console.log(res, "back end response"))
      .catch((err) => console.log(err, "error back end response"));
  };
  console.log(team, "hhh");

  return (
    <div
      className="relative z-10"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
      onClick={handleClose}
    >
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

      <div className="fixed inset-0 z-10 overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div
            onClick={(e) => e.stopPropagation()}
            className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg"
          >
            <div className="">
              <h1 className="py-2 px-5">Add Team Status</h1>
            </div>
            <div className="">
              <h1 className="py-2 px-5 text-sm">
                Winning Percentage:{~~percentage(win, loss, draw)}%
              </h1>
            </div>
            <form
              onSubmit={
                data?.teampercent_id == null ? handleCreate : handleUpdate
              }
            >
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="grid grid-cols-12 gap-3">
                  <div className="col-span-6">
                    {" "}
                    <label
                      for="name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Win
                    </label>
                    <input
                      value={win}
                      onChange={(e) => setwin(e.target.value)}
                      type="text"
                      id="first_name"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Name"
                      required
                    />
                  </div>
                  <div className="col-span-6">
                    {" "}
                    <label
                      for="name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Draw
                    </label>
                    <input
                      value={draw}
                      onChange={(e) => setdraw(e.target.value)}
                      type="text"
                      id="first_name"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Name"
                      required
                    />
                  </div>
                  <div className="col-span-6">
                    {" "}
                    <label
                      for="name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Loss
                    </label>
                    <input
                      value={loss}
                      onChange={(e) => setloss(e.target.value)}
                      type="text"
                      id="first_name"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Name"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                <button
                  type="submit"
                  className="inline-flex w-full justify-center rounded-md border border-transparent bg-[#67e8f9] px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-[#22d3ee] focus:outline-none focus:ring-2 focus:ring-[#22d3ee] focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  {data?.teampercent_id == null ? "Create" : "Update"}
                </button>
                <button
                  onClick={handleClose}
                  type="button"
                  className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
